var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('ProductDetails',{attrs:{"product":_vm.product}}),_c('ProductDescription',{attrs:{"product":_vm.product}}),_c('ShowcaseProducts',{attrs:{"products":_vm.products,"titleBox":_vm.translateTitleBox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }